import { FormEvent, useEffect, useState } from 'react';
import { api } from '../lib/api';
import AiAnswer from './AiAnswer';

type Msg = { role: 'user' | 'assistant'; text: string; costUsd?: number };

export default function AiGeneralBody() {
  const [history, setHistory] = useState<Msg[]>([]);
  const [prompt, setPrompt] = useState('');
  const [busy, setBusy] = useState(false);
  const [usage, setUsage] = useState<{ calls: number; cost_usd: number } | null>(null);

  async function refreshUsage() {
    try {
      const r = await api.get<{ last_30_days: { calls: number; cost_usd: number } }>(
        '/ai/usage'
      );
      setUsage(r.last_30_days);
    } catch {
      /* noop */
    }
  }

  useEffect(() => {
    refreshUsage();
  }, []);

  async function send(e: FormEvent) {
    e.preventDefault();
    if (!prompt.trim()) return;
    const userMsg = prompt.trim();
    setHistory((h) => [...h, { role: 'user', text: userMsg }]);
    setPrompt('');
    setBusy(true);
    try {
      const r = await api.post<{ answer: string; usage: { cost_usd: number } }>('/ai/ask', {
        prompt: userMsg,
      });
      setHistory((h) => [
        ...h,
        { role: 'assistant', text: r.answer, costUsd: r.usage?.cost_usd ?? 0 },
      ]);
      refreshUsage();
    } catch (err) {
      setHistory((h) => [
        ...h,
        {
          role: 'assistant',
          text: `Erreur : ${err instanceof Error ? err.message : 'inconnue'}`,
        },
      ]);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ai-general-body">
      <div className="ai-general-feed">
        {history.length === 0 && (
          <div className="card-meta" style={{ padding: 12 }}>
            Pose-moi une question transversale : normes, contraintes BIM, conseils. Pas lié à un
            document précis — pour ça, utilise l'assistant du document dans le volet.
          </div>
        )}
        {history.map((m, i) =>
          m.role === 'user' ? (
            <div
              key={i}
              style={{
                marginBottom: 8,
                padding: '8px 12px',
                background: 'var(--c-terracotta)',
                color: '#fff',
                borderRadius: 10,
                whiteSpace: 'pre-wrap',
                fontSize: 13.5,
                alignSelf: 'flex-end',
                maxWidth: '90%',
              }}
            >
              {m.text}
            </div>
          ) : (
            <div key={i} style={{ marginBottom: 8 }}>
              <AiAnswer
                title={`Question ${Math.ceil((i + 1) / 2)}`}
                text={m.text}
                costUsd={m.costUsd}
              />
            </div>
          )
        )}
        {busy && <div className="card-meta" style={{ padding: 10 }}>…</div>}
      </div>
      <form className="ai-general-foot" onSubmit={send}>
        <input
          placeholder="Question à l'IA…"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          disabled={busy}
        />
        <button className="btn btn-primary" disabled={busy}>
          ↑
        </button>
      </form>
      {usage && (
        <div className="card-meta" style={{ padding: '4px 12px 8px', fontSize: 11 }}>
          30j : {usage.calls} appels · ≈ {usage.cost_usd.toFixed(3)} USD
        </div>
      )}
    </div>
  );
}
